import StorageService from "./storage.service";

export default StorageService;
